import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const WasteTippingJobs = ({ tippingId, initialJobs, reviewed }) => {
  const [jobs, setJobs] = useState(initialJobs || []);
  const [availableJobs, setAvailableJobs] = useState([]);

  useEffect(() => {
    if (!reviewed) {
      console.log("Fetching available jobs for tipping:", tippingId);
      axios
        .get(`/jobs/waste-tipping/${tippingId}/available-jobs`)
        .then((res) => {
          console.log("Available jobs:", res.data);
          setAvailableJobs(res.data);
        })
        .catch((err) => console.error("Error fetching available jobs:", err));
    }
  }, [tippingId, reviewed]);

  function formatDateTime(dateTimeString) {
    if (!dateTimeString) return { date: "", time: "" };

    const [datePart] = dateTimeString.split(" ");
    if (!datePart) return { date: "", time: "" };

    const [year, month, day] = datePart.split("-");
    const formattedDate = `${day}-${month}-${year}`;

    return { date: formattedDate };
  }

  const removeJob = (jobId) => {
    Swal.fire({
      title: "Remove job?",
      text: "This job will no longer be linked",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove it",
    }).then((result) => {
      if (result.isConfirmed || result.value) {
        axios
          .delete(`/jobs/waste-tipping/${tippingId}/job/${jobId}`, {
            data: { _token: document.querySelector('meta[name="csrf-token"]').content },
          })
          .then(() => {
            const removedJob = jobs.find((j) => j.id === jobId);
            setJobs((prev) => prev.filter((j) => j.id !== jobId));
            if (removedJob) setAvailableJobs((prev) => [...prev, removedJob]);
          })
          .catch(() =>
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "Could not remove job",
            })
          );
      }
    });
  };

  return (
    <section className="mt-4">
      <div className="row py-4">
        <div className="col-12">
          <h6 className="py-2 pl-2 cw-bg-grey text-white">Jobs Linked to this Waste</h6>
        </div>
      </div>

      <div className="row transform-text">
        {jobs.map((job) => {
          const completion = job.completion_date;
          const { date } = formatDateTime(completion);

          return (
            <div key={job.id} className="col-md-6 mb-4">
              <p className="mb-0">
                Job id:{" "}
                <a href={`/jobs/${job.id}/dtn/edit`} target="_blank" rel="noreferrer">
                  {job.id}
                </a>
              </p>
              <p className="mb-0">Job type: {job.job_type?.name || ''}</p>
              <p className="my-0">Job address: {job.address_line_1 || ''}</p>
              <p className="my-0">Job completion date: {date || ''}</p>
              {!reviewed && (
                <button
                  className="btn btn-danger btn-sm mt-2"
                  onClick={(e) => {
                    e.preventDefault();
                    removeJob(job.id);
                  }}
                >
                  Remove job
                </button>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default WasteTippingJobs;
